export default __webpack_public_path__ + "static/media/home-shop-modern-04.0b826c59.jpg";